import { Routes } from '@angular/router';

import { ERoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const awardReasonRoutes: Routes = [
  {
    path: ERoutes.AWARD_REASON,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./award-reason-table/award-reason-table.component').then(
            (m) => m.AwardReasonTableComponent
          ),
      },
      {
        path: 'card',
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./award-reason-card/award-reason-card.component').then(
            (m) => m.AwardReasonCardComponent
          ),
      },
    ],
  },
];
